<template>
  <service
    data-aos="fade"
    :image="image"
    :title="title"
  >
    <p>
      Retreats are memorable occasions, and food plays an integral role in ensuring their
      success. My vibrant and creative, nutrient-rich cuisine will keep your guests feeling
      satisfied, inspired and nourished — and ensure that you, as the host, remain worry-free.
    </p>
    <p>
      From developing the menu to service, sourcing sustainable produce and choosing the
      ingredients, let me relieve you of stress and take care of organising the food for your
      retreat. I select nutritious ingredients based on what is seasonally available and use
      cooking methods aimed to highlight flavour, with each retreat's menu tailored to your
      preferences and requirements.
    </p>
    <p>
      I offer:
      <ul>
        <li>plant-based catering for day and longer retreats</li>
        <li>minimal to zero-waste</li>
        <li>bespoke seasonal menus</li>
        <li>3 meals a day with homemade herbal teas</li>
        <li>foraged, homegrown, locally sourced, and organic ingredients</li>
      </ul>
    </p>
    <p>
      All the dishes are made from scratch: from sourdough breads to plant milks and fermented
      plant yoghurts. I thrive in creatively using "waste" to create new dishes.
    </p>
    <p>
        Based in Hertford, UK, I travel around England, France and beyond.
    </p>
    <p>
        If you are interested in working together for your retreat, please email me at
        <a href="mailto:contact@chefnaturelle.com">contact@chefnaturelle.com</a> with
        the following information:
    </p>
    <p>
      <ul class="mb-8">
          <li>Date of your event</li>
          <li>Location</li>
          <li>Number of people</li>
      </ul>
    </p>
  </service>
</template>

<script>
import Service from '@/components/Service'
import MetaInfoBuilder from '@/utils/social'

export default {
  components: {
    Service,
  },
  data: () => ({
    description: '',
    image: require(`@/assets/images/retreat-catering-banner2.jpg?vuetify-preload`),
    title: 'Retreat Catering',
  }),
  metaInfo() {
    return new MetaInfoBuilder()
      .description(this.description)
      .image(`${window.location.origin}${this.image.src}`)
      .title(this.title)
      .build()
  }
}
</script>

<style scoped>
</style>
